import { render, staticRenderFns } from "./ControlsTreeControlSectionContextMenu.vue?vue&type=template&id=d137ea8e&"
import script from "./ControlsTreeControlSectionContextMenu.vue?vue&type=script&lang=ts&"
export * from "./ControlsTreeControlSectionContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ControlsTreeControlSectionContextMenu.vue?vue&type=style&index=0&id=d137ea8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports